export const HEADER_HEIGHT = 64

export const SMALL_MOBILE_BREAKPOINT = 575
export const MOBILE_BREAKPOINT = 767
export const SMALL_TABLET_BREAKPOINT = 1023
export const TABLET_BREAKPOINT = 1279
export const MOBILE_CSS_BREAKPOINT = `${MOBILE_BREAKPOINT + 1}px`
export const TABLET_CSS_BREAKPOINT = `${TABLET_BREAKPOINT + 1}px`

export const OFFSET_STEP = 4

export const DEFAULT_HEADER_HEIGHT = 64
export const TABLET_HEADER_HEIGHT = DEFAULT_HEADER_HEIGHT
export const MOBILE_HEADER_HEIGHT = 54
export const MOBILE_APP_BANNER = 54
export const MOBILE_SEARCH_HEIGHT = 54

export const DESKTOP_DEVICE = 'desktop'
export const MOBILE_DEVICE = 'mobile'
